/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { useDeviceType } from "../../../shared/hooks/useDeviceType";
import { useScreenOrientation } from "../../../shared/hooks/useScreenOrientation";
import { MediaType } from "../../../shared/types";
import { usePlayerCurrentMedia } from "../../Controller";

import { ToggleFullScreenButton, VolumeControl } from "./Component/Shared";
import {
  AirPlay,
  ChromecastButton,
  LiveButton,
  Metadata,
  PlayListButton,
  PlayPauseButton,
  SeekButton,
  SettingsToggleButton,
  Timeline,
  TimeMarker,
} from "./Component/Video";
import { NextEpisodeButton } from "./Component/Video/NextEpisodeButton";
import { SeasonsButton } from "./Component/Video/SeasonsButton";

import "./Controller.scss";

export const Controller = () => {
  const { isMobilePhoneDevice } = useDeviceType();
  const orientation = useScreenOrientation();
  const { media, playInfo } = usePlayerCurrentMedia();

  const isPortraitOrientation = orientation === "portrait";
  const hideOnMobilePortrait = isMobilePhoneDevice && isPortraitOrientation;

  return (
    <div className="PlayerController">
      <div className="PlayerController__Above">
        <div className="PlayerController__Above__Left">
          <Metadata />
        </div>
      </div>
      <div className="PlayerController__Timeline">
        <div className="PlayerController__Timeline__Progress">
          <Timeline withAdvertisementMarks />
        </div>
        <div className="PlayerController__Timeline__Marker">
          <TimeMarker />
        </div>
      </div>
      <div className="PlayerController__Buttons">
        <div className="PlayerController__Buttons__Left">
          <PlayPauseButton />
          {!hideOnMobilePortrait && <SeekButton isBackSeek />}
          {!hideOnMobilePortrait && <SeekButton />}
          {!hideOnMobilePortrait && <VolumeControl />}
          <LiveButton />
        </div>
        <div className="PlayerController__Buttons__Center" />
        <div className="PlayerController__Buttons__Right">
          {!hideOnMobilePortrait && <NextEpisodeButton />}
          {media.MediaTypeCode === MediaType.Episode && <SeasonsButton />}
          {playInfo.Playlist && <PlayListButton />}
          <SettingsToggleButton />
          <AirPlay />
          <ChromecastButton />
          <ToggleFullScreenButton />
        </div>
      </div>
    </div>
  );
};
